import {
  type ButtonHTMLAttributes,
  type DetailedHTMLProps,
  type ReactNode,
} from 'preact/compat';

import { type SvgImage } from '@/shared/types/common';

type HtmlButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export enum ButtonSize {
  l50 = 'l50',
  s30 = 's30',
}

export enum ButtonVariant {
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  volumeButton = 'volumeButton',
}

export interface ButtonProps extends HtmlButtonProps {
  icon?: SvgImage | ReactNode | string;
  size?: ButtonSize;
  variant?: ButtonVariant;

  counter?: ReactNode;

  shine?: boolean;
  media?: boolean;
  loading?: boolean;
  disabled?: boolean;
}
